import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Cookie } from 'lucide-react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Delay showing banner for better UX
      setTimeout(() => setShowBanner(true), 1500);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-[#1a2640] border border-[#d1af6a]/20 p-6 shadow-2xl">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex w-12 h-12 bg-[#d1af6a]/10 items-center justify-center flex-shrink-0">
                <Cookie className="w-6 h-6 text-[#d1af6a]" />
              </div>
              <div className="flex-1">
                <h3 className="font-subheading text-lg text-white mb-2">
                  Cookie-Einstellungen
                </h3>
                <p className="text-[#c8c6c4] text-sm leading-relaxed mb-4">
                  Wir verwenden Cookies, um Ihnen ein optimales Webseitenerlebnis zu bieten. 
                  Weitere Informationen finden Sie in unserer{' '}
                  <a href="/datenschutz" className="text-[#d1af6a] hover:underline">
                    Datenschutzerklärung
                  </a>.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={handleAccept}
                    className="btn-primary text-sm py-2"
                    data-testid="cookie-accept"
                  >
                    Alle akzeptieren
                  </button>
                  <button
                    onClick={handleDecline}
                    className="btn-secondary text-sm py-2"
                    data-testid="cookie-decline"
                  >
                    Nur notwendige
                  </button>
                </div>
              </div>
              <button
                onClick={handleDecline}
                className="text-[#c8c6c4] hover:text-white transition-colors"
                aria-label="Schließen"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
